import { InjectionToken } from '@angular/core';
import { BaseLineItemsDataService } from '../base-classes/base-line-items-data.service';

export const LINE_ITEMS_DATA_SERVICE = new InjectionToken<BaseLineItemsDataService>('LINE_ITEMS_DATA_SERVICE');
